module.exports = __webpack_public_path__ + "static/media/B_FD-cover.82ea0bbc.png";